
(function () {
    'use strict';

    angular
        .module('invesfleet')
        .filter('highlightFilter', highlightFilter);

    function highlightFilter($sce, $filter) {
        return function (text, phrase) {
            //console.log('highlightFilter >> ');
            //console.log('phrase >> ' + phrase);
            //console.log('text >> ' + text);
            if (phrase) {
                var cleanPhrase = $filter('cleanFilter')(phrase,null);
                var cleanText = $filter('cleanFilter')(text,null);
                
                var regex = new RegExp('(' + escapeRegExp(cleanPhrase) + ')', 'gi');
                var result, indices = [];
                while ( (result = regex.exec(cleanText)) ) {
                    indices.push(result.index);
                }

                if(indices.length === 0){ return $sce.trustAsHtml(text); }
                var newText = '';

                for(var i = 0; i < indices.length; i++){
                    var index = indices[i];

                    if(i > 0){
                        newText = newText + text.substring(indices[i-1] + phrase.length, index);
                    }else {
                        newText = newText + text.substring(0, index);
                    }

                    newText = newText + '<span class="jmelo-highlighted">' + 
                        text.substring(index, index + phrase.length) + '</span>';

                    if(i === indices.length -1){
                        newText = newText + text.substring(index + phrase.length, text.length);
                    }
                }

                return $sce.trustAsHtml(newText);
            }
            return $sce.trustAsHtml(text);
        };

        function escapeRegExp(str) {
            return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
        }
    }

})();